export default {
  supplyDocumentList: {
    method: 'post',
    url: '/client/supply/document/list'
  },
  supplyDocumentListById: {
    method: 'post',
    url: '/client/supply/document/list/ID'
  },
  supplyDocumentCreate: {
    method: 'post',
    url: '/client/supply/document'
  },
  supplyDocumentUpdate: {
    method: 'put',
    url: '/client/supply/document'
  },
  supplyDocumentDelete: {
    method: 'delete',
    url: '/client/supply/document'
  }
}
